import { useState, useEffect } from "react";


// Start : EC-845 - Custom Hook to check current view
const getCookie = (name: string): string | null => {
    if (typeof document === "undefined") return null; // Prevent SSR issues
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return match ? match[2] : null;
};

const useProductListView = () => {
    const [productListView, setProductListView] = useState(getCookie("ProductList-View"));

    useEffect(() => {
        const observer = new MutationObserver(() => {
            setProductListView(getCookie("ProductList-View"));
        });

        observer.observe(document, { subtree: true, childList: true });

        return () => observer.disconnect();
    }, []);

    return productListView;
};

export default useProductListView;
// End : EC-845 - Custom Hook to check current view
